import { render } from "./AddUnit.vue?vue&type=template&id=81873bbc&scoped=true"
import script from "./AddUnit.vue?vue&type=script&lang=js"
export * from "./AddUnit.vue?vue&type=script&lang=js"

import "./AddUnit.vue?vue&type=style&index=0&id=81873bbc&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81873bbc"]])

export default __exports__